// extracted by mini-css-extract-plugin
module.exports = {"prices":"_3uack","outOfStock":"_3DJ-f","priceBeforeDiscount":"_23IPr","priceToPay":"_23ArP"};